export default __webpack_public_path__ + "static/media/bus.f6afd477.pdf";